import { Component, OnInit, EventEmitter, Input, Output,  OnDestroy,  HostListener} from '@angular/core';
import { Unsubscribable } from 'rxjs';

@Component({
  selector: 'div.mitem',
  templateUrl: './dn-menu-item.component.html',
  styleUrls: ['../dn-menu.component.scss']

})

export class DnMenuItemComponent implements OnInit, OnDestroy {

 

  ngOnDestroy(): void {
    this.subscrption.forEach(p => p.unsubscribe());
  }
  @Input()
  menuItem;
  @Input()
  menuItemId;
  @Input()
  children = 0;

  @Output()
  mouseOverEvent = new EventEmitter<any>();
  //isActive = false;
  constructor(
    // private _route: ActivatedRoute,
    // private _router: Router,
    // private _menuService: MenuService,
    // private _categoryService: CategoryService,
    // @Inject(AppStore) private store: Store<VideoState>,
  ) {

  }
  private subscrption: Array<Unsubscribable> = [];

  // readState() {
  //   const allState = this.store.getState();
  //   const videoState: VideoState = allState['video'] as VideoState;
  //   const baseUrl = this._router.url.split('?')[0].substr(1).split('/')[0];
  //   if (videoState.currentVideo && baseUrl === 'video') {

  //     if (this.menuItem.cid === videoState.currentVideo.cid) {
  //       this.isActive = true;
  //     } else {
  //       const c = this._menuService.getMenuItemBySlug(videoState.currentVideo.category);
  //       if (c && c.cid === this.menuItem.cid) {
  //         this.isActive = true;
  //       } else {
  //         this.isActive = false;
  //       }
  //     }
  //   }
  // }

  baseFilter = ["tag", 'region']
  ngOnInit() {
   // this.isActive = false;

    // this._route.queryParams.subscribe((queryParams: any) => {
    //   const baseUrl = this._router.url.split('?')[0].substr(1).split('/')[0];

    //   this.isActive = false;
    //   const cid = queryParams.cid;

    //   if (baseUrl === 'list' && queryParams.hasOwnProperty('cid')) {
    //     if (!this.menuItem.params || !this.menuItem.params.hasOwnProperty('cid')) {
    //       this.isActive = false;
    //       return;
    //     }

    //     const parentMenuItem = this._menuService.getParentMenuItemByCid(cid);

    //     if (cid && this.menuItem.params
    //       && parentMenuItem.params
    //       && this.menuItem.params.cid === parentMenuItem.params.cid
    //       && this.menuItem.params.tag === parentMenuItem.params.tag
    //       && this.menuItem.params.region == parentMenuItem.params.region
    //     ) {
    //       this.isActive = true;
    //       return;
    //     }
    //   }

    //   if (baseUrl === 'short-videos' && queryParams.hasOwnProperty('cid')) {
    //     if (!this.menuItem.params || !this.menuItem.params.hasOwnProperty('cid')) {
    //       this.isActive = false;
    //       return;
    //     }
    //     const parentMenuItem = this._menuService.getParentMenuItemByCid(cid);
    //     if (cid && this.menuItem.params
    //       && parentMenuItem.params
    //       && this.menuItem.params.cid === parentMenuItem.params.cid
    //       && this.menuItem.params.tag === parentMenuItem.params.tag
    //       && this.menuItem.params.region == parentMenuItem.params.region
    //     ) {
    //       this.isActive = true;
    //       return;
    //     }
    //   }

    //   if (baseUrl === 'list' && queryParams.hasOwnProperty('tag')) {
    //     // 喜好
    //     if ((this.menuItem.routerLink === '/list') && (this.menuItem.params === null)) {

    //       this.isActive = true;
    //       return;
    //     }
    //   }

    //   var has = false;
    //   for (const key in queryParams) {
    //     if (this.menuItem.params && this.menuItem.params.hasOwnProperty(key)) {
    //       if (this.baseFilter.includes(key)) {
    //         has = true;
    //         if (this.menuItem.params.hasOwnProperty(key)) {
    //           if (this.menuItem.params[key].toString() === queryParams[key]) {

    //             this.isActive = true;
    //             return;
    //           }
    //         } else {
    //           if (this.menuItem.params[key].toString() === queryParams[key]) {
    //             this.isActive = true;
    //             return;
    //           }
    //         }
    //       }
    //     }
    //   }

    //   if (baseUrl === 'list') {
    //     if (!!cid && cid.split(',').length >= 3
    //       && cid == this.menuItem.params.cid && !has) {
    //       if (cid.split(',').length == 3) {
    //         var length = Object.keys(this.menuItem.params).length;
    //         if (length == 1) {
    //           this.isActive = true;
    //         }
    //       } else {
    //         this.isActive = true
    //         return;
    //       }
    //     }
    //   }
    // });

    // this.subscrption.push(
    //  this._router.events.subscribe((event) => {
    //   if (event instanceof NavigationEnd) {
    //     const baseUrl = this._router.url.split('?')[0].substr(1).split('/')[0];
    //     if (baseUrl !== 'list' && baseUrl !== 'short-videos') {
    //       this.isActive = false;
    //       if (baseUrl === this.menuItem.routerLink.substring(1)) {
    //         this.isActive = true;
    //       }
    //     }
    //   }
    // }));
  }
  @HostListener("mouseenter")
  onMouseEnter() {
    this.mouseOverEvent.emit(this.menuItemId);
  }
}
